import { cn, initials } from "@/lib/utils";

const SIZES = { sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-16 w-16 text-xl" } as const;

export function Avatar({ name, src, size = "md", className }: { name: string; src?: string | null; size?: keyof typeof SIZES; className?: string }) {
  return src ? (
    <img src={src} alt={name} className={cn("rounded-full object-cover ring-2 ring-card", SIZES[size], className)} />
  ) : (
    <span
      role="img"
      aria-label={name}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary to-accent font-semibold text-white ring-2 ring-card",
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
